import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import {InputText} from 'primereact/inputtext'
import React, {useEffect, useRef} from 'react'
import {useDebouncedCallback} from 'use-debounce'
import {ReactComponent as DuoWebSearch} from '../../assets/icons/DuoSearcWeb.svg'
import TranslateUtils from '../../i18n/TranslateUtils'
import {useDatatableContext} from './DataTableContext'
import './styles.css'

const StyledSearchBox = () => {
    useSignals()

    const {translateDatatable} = TranslateUtils()
    const {handleChangeGlobalSearch} = useDatatableContext()

    const inputRef = useRef(null)
    const clearSearchRef = useRef(null)

    const globalSearch = useSignal('')
    const isDebouncingGlobalSearch = useSignal(false)
    const debounced = useDebouncedCallback(value => {
        globalSearch.value = value
        isDebouncingGlobalSearch.value = false

        if (handleChangeGlobalSearch) {
            handleChangeGlobalSearch(value)
        }
    }, 500)

    useEffect(() => {
        if (clearSearchRef.current) {
            clearSearchRef.current?.classList?.add('hidden')
        }
    }, [])

    return (
        <div className="flex-none">
            <div className="flex align-items-center justify-content-between">
                <h6 className="text-gray-500 font-bold m-0 mb-1 ">
                    {translateDatatable('Search')}
                </h6>
                <div
                    ref={clearSearchRef}
                    className="cursor-pointer text-gray-600 text-danger"
                    onClick={() => {
                        inputRef.current.value = ''
                        globalSearch.value = ''
                        isDebouncingGlobalSearch.value = false

                        if (clearSearchRef.current) {
                            clearSearchRef.current?.classList?.add('hidden')
                        }

                        if (handleChangeGlobalSearch) {
                            handleChangeGlobalSearch('')
                        }
                    }}>
                    <i className="pi pi-times mr-1"></i>
                    <span>{translateDatatable('Clear')}</span>
                </div>
            </div>

            <div className="p-inputgroup pt-2">
                <React.Fragment>
                    <InputText
                        ref={inputRef}
                        placeholder={translateDatatable('Input search keyword')}
                        style={{
                            '--inputColor': 'rgba(68, 184, 166, 0.1)',
                        }}
                        defaultValue={''}
                        onChange={e => {
                            if (!e.target.value) {
                                clearSearchRef.current?.classList?.add('hidden')
                            } else {
                                clearSearchRef.current?.classList?.remove(
                                    'hidden',
                                )
                            }

                            isDebouncingGlobalSearch.value = true
                            debounced(e.target.value)
                        }}
                    />
                    <span className="p-inputgroup-addon bg-teal-500 border-gray-50 ">
                        <DuoWebSearch
                            className="text-white"
                            height={20}
                            width={20}
                        />
                        {/* <i
                            className={`pi ${
                                isDebouncingGlobalSearch.value
                                    ? 'pi-spinner pi-spin'
                                    : 'pi-search'
                            }`}></i> */}
                    </span>
                </React.Fragment>
            </div>
        </div>
    )
}

export default StyledSearchBox
